import Tag from '#globalComponents/Tag/Tag';

const BADGES = {
	pending_review: { label: 'Ausstehend', tone: 'caution' },
	approved: { label: 'Genehmigt', tone: 'success' },
	rejected: { label: 'Abgelehnt', tone: 'warning' },
	edited: { label: 'Bearbeitet', tone: 'primary' },
};

export const getStatusBadge = (status) => {
	const badge = BADGES[status] || BADGES.pending_review;

	return <Tag label={badge.label} tone={badge.tone} />;
};
